import { IconComponentsProps } from './types';

const CheckIcon = ({ fill = 'black', ...props }: IconComponentsProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.5 12L2 7.5L2.707 6.793L6.5 10.5855L13.293 3.793L14 4.5L6.5 12Z" fill={fill} />
  </svg>
);

export default CheckIcon;
